<div class="outer-box">
  <div class="ghost">
    <span class="text">404</span>
    <div class="eye"></div>
    <div class="eye two"></div>
    <div class="mouth"></div>
    <div class="corner"></div>
    <div class="corner two"></div>
    <div class="corner three"></div>
    <div class="corner four"></div>
    <div class="over"></div>
    <div class="over two"></div>
    <div class="over three"></div>
    <div class="over four"></div>
    <div class="shadow"></div>
  </div>

  <div class="main">
    <div class="error">error</div>
    <h2>Page not found</h2>
    <h6>The page you are looking for might have been removed, had its name changed,<br />or is temporarily unavailable.</h6>
    <button class="back-btn" (click)="goBack()">&#8592; Go Back</button>
  </div>
</div>